<div>
    <h2 class="mat-title">
        Course Adoption Requests Editor
    </h2>
    <div>
        <div *ngIf="Adoptions">There are currently {{Adoptions.length}} course adoption requests in the DELTA system, with {{PendingCount}} requests pending review. Please use the tools below to review, approve, or deny course adoption requests in the system.</div>
    </div>
    <button type="button" mat-raised-button color="primary" (click)="DownloadAdoptionRequestsSpreadsheet()">Download Requests</button>

    <!-- Adoptions Table -->
    <mat-table class="bordered" #table [dataSource]="AdoptionsData" matSort matSortActive="Prefix" matSortDirection="asc">
        <ng-container matColumnDef="RequestNumber">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered"><span>Request #</span></mat-header-cell>
            <mat-cell *matCellDef="let req" class="centered"><span>{{req.AdoptionRequestID}}</span></mat-cell>
        </ng-container>

        <!-- <ng-container matColumnDef="Prefix">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Prefix</mat-header-cell>
            <mat-cell *matCellDef="let req" class="centered">{{req.Prefix}}</mat-cell>
        </ng-container> -->

        <ng-container matColumnDef="Code">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Code</mat-header-cell>
            <mat-cell *matCellDef="let req" class="centered">{{req.Code}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Name">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Name</mat-header-cell>
            <mat-cell *matCellDef="let req" class="centered">{{req.Name}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Requestor">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Requestor</mat-header-cell>
            <mat-cell *matCellDef="let req" class="centered">{{req.RequestedByFirstName | titleCase}} {{req.RequestedByLastName | titleCase}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="DateRequested">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Date Requested</mat-header-cell>
            <mat-cell *matCellDef="let req" class="centered">{{req.DateRequested | datefns:'M/D/YYYY h:mm A'}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Status">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Status</mat-header-cell>
            <mat-cell *matCellDef="let req" class="centered" [ngSwitch]="req.Approved">
                <span *ngSwitchCase="true">Approved</span>
                <span *ngSwitchCase="false">Denied</span>
                <span *ngSwitchDefault>Pending</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Colleges">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Colleges</mat-header-cell>
            <mat-cell *matCellDef="let req" class="centered">
                <app-tags
                    [options]="TagOptions"
                    [tagData]="req.Colleges"
                    [tagType]="TagTypes.College"
                    [allowEdit]="false"
                    [canRemove]="false"
                >
                </app-tags>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Actions">
            <mat-header-cell *matHeaderCellDef class="centered">Action(s)</mat-header-cell>
            <mat-cell *matCellDef="let req" class="centered">
                <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="15px" class="paddingtop paddingbottom">
                    <button mat-raised-button color="primary" (click)="ShowAdoptionRequestInfo(req)">View</button>
                    <button *ngIf="req.Approved == null" mat-raised-button color="primary" (click)="ApproveRequest(req)">Approve</button>
                    <button *ngIf="req.Approved == null" mat-raised-button color="warn" (click)="DenyRequest(req)">Deny</button>
                </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="SmallDisplay">
            <mat-header-cell *matHeaderCellDef class="centered">Course Adoption Request(s)</mat-header-cell>
            <mat-cell *matCellDef="let req">
                <div fxLayout="column" fxLayoutAlign="start stretch">
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <form-label>Request #</form-label>
                        <div>{{req.AdoptionRequestID}}</div>
                    </div>
                    <!-- <div fxLayout="row" fxLayoutAlign="space-between center">
                        <form-label>Prefix</form-label>
                        <div>{{req.Prefix}}</div>
                    </div> -->
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <form-label>Code</form-label>
                        <div>{{req.Code}}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <form-label>Name</form-label>
                        <div>{{req.Name}}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <form-label>Requestor</form-label>
                        <div>{{req.RequestedByFirstName | titleCase}} {{req.RequestedByLastName | titleCase}}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <form-label>Date Requested</form-label>
                        <div>{{req.DateRequested | datefns:'M/D/YYYY h:mm A'}}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <form-label>Status</form-label>
                        <div [ngSwitch]="req.Approved">
                            <span *ngSwitchCase="true">Approved</span>
                            <span *ngSwitchCase="false">Denied</span>
                            <span *ngSwitchDefault>Pending</span>
                        </div>
                    </div>
                    <div class="smalldisplaybuttongroup" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
                        <button mat-raised-button color="primary" (click)="ShowAdoptionRequestInfo(req)">View</button>
                        <button *ngIf="req.Approved == null" mat-raised-button color="primary" (click)="ApproveRequest(req)">Approve</button>
                        <button *ngIf="req.Approved == null" mat-raised-button color="warn" (click)="DenyRequest(req)">Deny</button>
                    </div>
                </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="NoData">
            <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
            <mat-cell *matCellDef="let req"><em>No course adoption requests have been made in the system.</em></mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="VisibleHeaders"></mat-header-row>
        <mat-row *matRowDef="let row;columns: VisibleColumns;let $even = even" [class.primarybackground50]="$even"></mat-row>
    </mat-table>
    <mat-paginator #paginator [length]="AdoptionsData.data.length" [pageIndex]="0" [pageSize]="(SmallDisplay ? 5 : 10)" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
</div>


// WEBPACK FOOTER //
// ./src/app/manageadoptions/manageadoptions.component.html